import Vue from 'vue'
import * as sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import SentryRRWeb from '@sentry/rrweb'
import { isOnline } from '@/config'
import router from '@/router'
import wj from '@/plugins/wjtools'
import { flatObject } from '@/plugins/wjtools/util'

// 初始化 Sentry 监控
if (isOnline) {
  sentry.init({
    Vue,
    // 调试模式
    // debug: !isOnline,
    // Sentry 项目的 dsn，可从项目设置中获取
    dsn: 'https://ee3cecd0f32f4080944760d0d5cde39b@monitor.kjhaoyun.com/6',
    // 版本信息
    release: process.env.VUE_APP_RELEASE,
    // 环境信息
    environment: process.env.NODE_ENV,
    // 采样率——触发异常后发送给 Sentry 的概率
    tracesSampleRate: 1.0,
    // 钩子函数，在每次发送 event 前触发
    beforeSend(event) {
      event.tags = { channel: wj.session('channelid') }
      event.user = {
        id: wj.cookie('userid'),
        name: wj.cookie('username'),
        username: wj.cookie('username'),
        token: wj.cookie('token'),
        url: document.URL
      }
      return event
    },
    // 集成配置
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['www.kjhaoyun.com', /^\//]
      }),
      // 使用指南：https://github.com/rrweb-io/rrweb/blob/master/guide.zh_CN.md
      new SentryRRWeb({
        checkoutEveryNms: 5 * 60 * 1000, // 每 x 秒重新制作快照
        // checkoutEveryNth: 300, // 每 x 个 event 重新制作快照
        // blockSelector: '.rr-block, audio, video, canvas', // 不录制的选择器
        maskAllInputs: false // 将所有输入内容记录为 *
      })
    ]
  })
}

// 手动上报
export function sentryReport(message, extraData, type = 'message') {
  if (!isOnline) return

  // 添加标签和用户信息
  // sentry.setTag('channel', wj.session('channelid'))
  // sentry.setUser({
  //   id: wj.cookie('userid'),
  //   name: wj.cookie('username'),
  //   username: wj.cookie('username'),
  //   token: wj.cookie('token'),
  //   url: document.URL
  // })

  // 添加附加信息
  extraData && sentry.setExtra(extraData.title || '附加信息', flatObject(extraData))

  // 上报信息
  // sentry[type === 'error' ? 'captureException' : 'captureMessage'](message)

  // 延迟上报
  setTimeout(() => {
    sentry[type === 'error' ? 'captureException' : 'captureMessage'](message)
  }, 1000)
}

Vue.prototype.$sentryReport = sentryReport

export default sentry
